// extracted by mini-css-extract-plugin
module.exports = {"chatSliderContainer":"az_m9","chatSliderImgContent":"az_n9","liveChat":"az_o9","sr":"az_p9","chatBtn":"az_q9"};